/***
 * File name: app.js
 *
 * Program Description:
 * This file contains all the static meta data for the whole system which includes
 * texts, system colors, and images
 *
 */
const app = {
  title: 'Data Breach Notification Management System',
  department: 'National Privacy Commission',
  logo: '/img/npc-logo.png',
  login: {
    background: '#FFF',
    text: '#FFF',
    primary: '#2c3e50'
  },
  userIcon: '/img/user-icon.png',
  landingPage: '/img/GirlLaptop.svg',
  dataPrivacy: 'Terms & Conditions',
  resetPass: '/img/reset-pass.png',
  land: 'img/land.png',
  selfAssessmentImage: '/img/exclamationPerson.png'
}
export default app
